'use client';

import { Card, CardContent, ToastProvider } from '@shared/ui';
import { TSidebarLayoutProps } from '../model';
import { Sidebar } from './Sidebar';
import { useMobile } from '@shared/hooks';

export const SidebarLayout = ({
  title,
  sidebarLinks,
  sidebarIcon,
  children,
}: TSidebarLayoutProps) => {
  const isMobile = useMobile();

  if (isMobile) {
    return (
      <>
        <ToastProvider position={'top-center'} />
        <div className='flex flex-col min-h-[100svh]'>
          <div className='flex flex-row w-full gap-x-3 min-h-[100svh]'>
            <div className='bg-hover w-full'>
              <div className='flex gap-0 md:gap-4'>{children}</div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <ToastProvider position={'top-center'} />
      <div className='layout flex flex-col pt-[24px]'>
        <h1 className='h3 mb-[16px]'>{title}</h1>
        <Card className='bg-background w-full'>
          <CardContent className='flex flex-col p-5 items-start justify-center'>
            <div className='flex flex-row w-full gap-x-3'>
              <div className='bg-background w-full'>
                <div className='flex gap-4'>
                  <Sidebar sidebarLinks={sidebarLinks} sidebarIcon={sidebarIcon} />
                  {children}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
